import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../../auth';
import { Loading } from '../index';
import { ProfileView } from '../Profile/ProfileView';

// Profile Protected Route Component
export function ProfileProtectedRoute({ path, exact }) {
  const auth = useAuth();
  const session = auth.sessionV2 || auth.session || auth.user;
  const hasCheckedAuth = auth.authChecked;

  return (
    <Route 
      path={path} 
      exact={exact}
      render={props => {
        // Show loading briefly while checking auth
        if (!hasCheckedAuth) {
          return (
            <div style={{padding: '2rem', textAlign: 'center'}}>
              <Loading />
              <p>Checking authentication...</p>
            </div>
          );
        }
        
        // If not authenticated, redirect to login
        if (!session) {
          return <Redirect to="/login" />;
        }
        
        // If authenticated, render profile
        return <ProfileView {...props} />;
      }}
    />
  );
} 